import React from 'react';
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import './GlobalNetwork.css';
import camerron from '../../../icons/CameroonNew.png';
import congo from '../../../icons/CongoNew.png';
import Heading from '../../../utls/Heading';

const GlobalNetwork = () => {
    return (
        <>
            <div className="global-netwrok">
                <div className="container">
                    <div className="row px-md-5 ps-2">
                        <div className="col-md-12">
                            <Heading className='customheadings'><span>Our</span> Global Presence</Heading>
                            <p className='global-netwrok-p'>Explore the reach of Blueberry Travel as we connect you to different destinations worldwide. With offices in major cities around the globe, we’re dedicated to providing a flawless travel experience wherever your journey takes you. Discover how our expertise in global networks comes along to support your travel needs. </p>
                        </div>
                    </div>
                </div>
                <div className=" network-back">
                    <div className="container">
                        <div className="row px-md-5 ps-2">
                            <div className="col-md-4 my-md-5 p-left-img">
                            <div className="d-flex gap-3  mb-md-3 mb-1">
                                    <LazyLoadImage
             
 src="https://blueberrywebsites.azureedge.net/bbt/icons/CountryIcons/Algeria.png" alt=""  loading="lazy" />
                                    <p className='country-name'>Algeria</p>
                                </div>
                                <div className="d-flex gap-3  mb-md-3 mb-1">
                                    <LazyLoadImage
             
 src="https://blueberrywebsites.azureedge.net/bbt/images/Angola.png" alt="" loading="lazy" />
                                    <p className='country-name'>Angola</p>
                                </div>
                                {/* <div className="d-flex gap-3  mb-md-3 mb-1">
                                    <LazyLoadImage
             
 src="https://blueberrywebsites.azureedge.net/bbt/images/Boatswana.png" alt="" loading="lazy"  />
                                    <p className='country-name'>Botswana</p>
                                </div> */}
                                <div className="d-flex gap-3  mb-md-3 mb-1">
                                    <LazyLoadImage
             
 src={camerron} alt="" loading="lazy"  />
                                    <p className='country-name'>Cameroon</p>
                                </div>
                                <div className="d-flex gap-3  mb-md-3 mb-1">
                                    <LazyLoadImage
             
 src="https://blueberrywebsites.azureedge.net/bbt/images/CAR.png" alt="" loading="lazy"  />
                                    <p className='country-name'>C.A.R</p>
                                </div>
                                <div className="d-flex gap-3  mb-md-3 mb-1">
                                    <LazyLoadImage
             
 src={congo} alt=""  loading="lazy" />
                                    <p className='country-name'>Congo</p>
                                </div>
                                {/* <div className="d-flex gap-3  mb-md-3 mb-1">
                                    <LazyLoadImage
             
 src="https://blueberrywebsites.azureedge.net/bbt/images/Co.png" alt="" loading="lazy" />
                                    <p className='country-name'>Cô te d'Ivoire</p>
                                </div> */}
                               
                                <div className="d-flex gap-3  mb-md-3 mb-1">
                                    <LazyLoadImage
             
 src="https://blueberrywebsites.azureedge.net/bbt/images/Gabon.png" alt=""  loading="lazy" />
                                    <p className='country-name'>Gabon</p>
                                </div>
                                <div className="d-flex gap-3  mb-md-3 mb-1">
                                    <LazyLoadImage
             
 src="https://blueberrywebsites.azureedge.net/bbt/images/Ghana.png" alt="" loading="lazy"  />
                                    <p className='country-name'>Ghana</p>
                                </div>
                                <div className="d-flex gap-3  mb-md-3 mb-1">
                                    <LazyLoadImage
             
 src="https://blueberrywebsites.azureedge.net/bbt/images/India.png" alt="" loading="lazy"  />
                                    <p className='country-name'>India</p>
                                </div>
                               
                            </div>




                            <div className="col-md-4 my-md-5 pLeft-location">
                                
                                
                                <div className="d-flex gap-3  mb-md-3 mb-1">
                                    <LazyLoadImage
             
 src="https://blueberrywebsites.azureedge.net/bbt/images/Kenya.png" alt="" loading="lazy"  />
                                    <p className='country-name'>Kenya</p>
                                </div>
                                <div className="d-flex gap-3  mb-md-3 mb-1">
                                    <LazyLoadImage
             
 src="https://blueberrywebsites.azureedge.net/bbt/images/Madagascar.png" alt=""  loading="lazy" />
                                    <p className='country-name'>Madagascar</p>
                                </div>
                                <div className="d-flex gap-3  mb-md-3 mb-1">
                                    <LazyLoadImage
             
 src="https://blueberrywebsites.azureedge.net/bbt/images/Malawi.png" alt=""  loading="lazy" />
                                    <p className='country-name'>Malawi</p>
                                </div>
                                <div className="d-flex gap-3  mb-md-3 mb-1">
                                    <LazyLoadImage
             
 src="https://blueberrywebsites.azureedge.net/bbt/images/Mazambique.png" alt=""  loading="lazy" />
                                    <p className='country-name'>Mozambique</p>
                                </div>
                                <div className="d-flex gap-3  mb-md-3 mb-1">
                                    <LazyLoadImage
             
 src="https://blueberrywebsites.azureedge.net/bbt/images/Namibia.png" alt="" loading="lazy" />
                                    <p className='country-name'>Namibia</p>
                                </div>
                                <div className="d-flex gap-3  mb-md-3 mb-1">
                                    <LazyLoadImage
             
 src="https://blueberrywebsites.azureedge.net/bbt/images/Nigeria.png" alt="" loading="lazy" />
                                    <p className='country-name'>Nigeria</p>
                                </div>
                               
                                <div className="d-flex gap-3  mb-md-3 mb-1">
                                    <LazyLoadImage
             
 src="https://blueberrywebsites.azureedge.net/bbt/images/RDC.png" alt="" loading="lazy" />
                                    <p className='country-name'>RDC</p>
                                </div>
                                <div className="d-flex gap-3  mb-md-3 mb-1">
                                    <LazyLoadImage
             
 src="https://blueberrywebsites.azureedge.net/bbt/icons/CountryIcons/senegal.png" alt=""  loading="lazy" />
                                    <p className='country-name'>Senegal</p>
                                </div>
                                {/* <div className="d-flex gap-3  mb-md-3 mb-1">
                                    <LazyLoadImage
             
 src="https://blueberrywebsites.azureedge.net/bbt/icons/CountryIcons/Rwanda.png" alt=""  loading="lazy" />
                                    <p className='country-name'>Rwanda</p>
                                </div> */}
                            </div>




                            <div className="col-md-4 my-md-5 pLeft-location2">
                          
                                <div className="d-flex gap-3  mb-md-3 mb-1">
                                    <LazyLoadImage
             
 src="https://blueberrywebsites.azureedge.net/bbt/images/South%20Africa.png" alt="" loading="lazy" />
                                    <p className='country-name'>South Africa</p>
                                </div>
                                <div className="d-flex gap-3  mb-md-3 mb-1">
                                    <LazyLoadImage
             
 src="https://blueberrywebsites.azureedge.net/bbt/images/Tanzania.png" alt="" loading="lazy" />
                                    <p className='country-name'>Tanzania</p>
                                </div>
                                <div className="d-flex gap-3  mb-md-3 mb-1">
                                    <LazyLoadImage
             
 src="https://blueberrywebsites.azureedge.net/bbt/images/Togo.png" alt="" loading="lazy" />
                                    <p className='country-name'>Togo</p>
                                </div>
                                <div className="d-flex gap-3  mb-md-3 mb-1">
                                    <LazyLoadImage
             
 src="https://blueberrywebsites.azureedge.net/bbt/images/UAE.png" alt="" loading="lazy" />
                                    <p className='country-name'>UAE</p>
                                </div>
                                <div className="d-flex gap-3  mb-md-3 mb-1">
                                    <LazyLoadImage
             
 src="https://blueberrywebsites.azureedge.net/bbt/images/Uganda.png" alt=""  loading="lazy" />
                                    <p className='country-name'>Uganda</p>
                                </div>
                                <div className="d-flex gap-3  mb-md-3 mb-1">
                                    <LazyLoadImage
             
 src="https://blueberrywebsites.azureedge.net/bbt/images/Zambia.png" alt="" loading="lazy"  />
                                    <p className='country-name'>Zambia</p>
                                </div>
                                <div className="d-flex gap-3  mb-md-3 mb-1">
                                    <LazyLoadImage
             
 src="https://blueberrywebsites.azureedge.net/bbt/images/Zimbabwe.png" alt="" loading="lazy"  />
                                    <p className='country-name'>Zimbabwe</p>
                                </div>
                                
                                {/* <div className="d-flex gap-3  mb-md-3 mb-1">
                                    <LazyLoadImage
             
 src="https://blueberrywebsites.azureedge.net/bbt/icons/CountryIcons/Burkina.png" alt=""  loading="lazy" />
                                    <p className='country-name'>Burkina</p>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default GlobalNetwork